<div class="set-screen">

  <!-- Fejléc — design 13-beallitasok.html -->
  <div class="set-head">
    <div class="set-head__copy">
      <h1 class="stk-page-title">Beállítások · Kalkuláció</h1>
      <div class="stk-page-sub">Itt állítod be a díjakat, adókat és a gyártási költséget — ezekből számol a rendszer profitot a rendeléseknél.</div>
    </div>
    <button
      type="button"
      class="stk-btn stk-btn--accent"
      [disabled]="savingCalc || calcLoading"
      (click)="saveCalculationSettings()">
      {{ savingCalc ? 'Mentés…' : 'Kalkuláció mentése' }}
    </button>
  </div>

  <div class="stk-info-bar set-calc-warn" *ngIf="calcLoadFailed">
    <span>A kalkulációs beállítások még nem érhetők el a szerveren — az itt felvett értékek mentéskor kerülnek rögzítésre.</span>
    <button type="button" class="stk-btn stk-btn--ghost set-retry" (click)="fetchCalculationSettings()">Újrapróbálom</button>
  </div>

  <!-- Webshop díjak -->
  <div class="set-card set-card--flush set-fees">
    <div class="set-card__head">
      <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#21252B" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="6" width="18" height="13" rx="2"></rect><line x1="3" y1="10" x2="21" y2="10"></line></svg>
      <h3>Webshop díjak</h3>
      <span class="set-card__hint">tranzakció · fizetési díj · listázás</span>
    </div>

    <div class="set-fee-grid set-fee-grid--head">
      <div class="stk-table-head">Webshop</div>
      <div class="stk-table-head">Tranzakció %</div>
      <div class="stk-table-head">Fizetés %</div>
      <div class="stk-table-head">Fix díj</div>
      <div class="stk-table-head">Listázás</div>
      <div></div>
    </div>

    <div class="set-fee-grid" *ngFor="let f of feeShops; let i = index">
      <input class="set-name-input" [value]="f.name" (change)="onFeeNameChange($event, f)">
      <label class="set-fee-cell" data-label="Tranz. %"><input class="set-num-input" [value]="f.txn" (change)="onFeeNumChange($event, f, 'txn')"></label>
      <label class="set-fee-cell" data-label="Fizetés %"><input class="set-num-input" [value]="f.pay" (change)="onFeeNumChange($event, f, 'pay')"></label>
      <label class="set-fee-cell" data-label="Fix díj"><input class="set-num-input" [value]="f.fixed" (change)="onFeeNumChange($event, f, 'fixed')"></label>
      <label class="set-fee-cell" data-label="Listázás"><input class="set-num-input" [value]="f.listing" (change)="onFeeNumChange($event, f, 'listing')"></label>
      <button type="button" class="set-del" title="Törlés" (click)="removeFeeShop(i)">
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><line x1="4" y1="7" x2="20" y2="7"></line><path d="M9 7 V5 a1 1 0 0 1 1 -1 h4 a1 1 0 0 1 1 1 v2"></path><path d="M6 7 l1 13 a1 1 0 0 0 1 1 h8 a1 1 0 0 0 1 -1 l1 -13"></path></svg>
      </button>
    </div>

    <div class="set-empty" *ngIf="calcLoading">Betöltés…</div>
    <div class="set-empty" *ngIf="!calcLoading && feeShops.length === 0">Még nincs webshop felvéve.</div>

    <button type="button" class="set-add" (click)="addFeeShop()">
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><line x1="12" y1="4" x2="12" y2="20"></line><line x1="4" y1="12" x2="20" y2="12"></line></svg>
      Új webshop hozzáadása
    </button>
  </div>

  <div class="set-two-col">

    <!-- ÁFA országonként -->
    <div class="set-card set-card--flush">
      <div class="set-card__head">
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#21252B" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"></circle><path d="M8 15 L16 9"></path><circle cx="9" cy="10" r="1"></circle><circle cx="15" cy="14" r="1"></circle></svg>
        <h3>ÁFA országonként</h3>
      </div>

      <div class="set-rate-row" *ngFor="let v of vatRates; let i = index">
        <input class="set-name-input set-rate-row__country" [value]="v.country" (change)="onRateCountryChange($event, v)">
        <div class="set-rate-row__val">
          <input class="set-num-input set-num-input--rate" [value]="v.rate" (change)="onRateChange($event, v)">
          <span>%</span>
        </div>
        <button type="button" class="set-del" title="Törlés" (click)="removeVatRate(i)">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><line x1="4" y1="7" x2="20" y2="7"></line><path d="M9 7 V5 a1 1 0 0 1 1 -1 h4 a1 1 0 0 1 1 1 v2"></path><path d="M6 7 l1 13 a1 1 0 0 0 1 1 h8 a1 1 0 0 0 1 -1 l1 -13"></path></svg>
        </button>
      </div>

      <div class="set-empty" *ngIf="calcLoading">Betöltés…</div>
      <div class="set-empty" *ngIf="!calcLoading && vatRates.length === 0">Még nincs ország felvéve.</div>

      <button type="button" class="set-add" (click)="addVatRate()">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><line x1="12" y1="4" x2="12" y2="20"></line><line x1="4" y1="12" x2="20" y2="12"></line></svg>
        Új ország
      </button>
    </div>

    <!-- Vám országonként -->
    <div class="set-card set-card--flush">
      <div class="set-card__head">
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#21252B" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3 L20 7 V12 C20 17 16.5 20 12 21 C7.5 20 4 17 4 12 V7 Z"></path></svg>
        <h3>Vám országonként</h3>
      </div>

      <div class="set-rate-row" *ngFor="let d of dutyRates; let i = index">
        <input class="set-name-input set-rate-row__country" [value]="d.country" (change)="onRateCountryChange($event, d)">
        <div class="set-rate-row__val">
          <input class="set-num-input set-num-input--rate" [value]="d.rate" (change)="onRateChange($event, d)">
          <span>%</span>
        </div>
        <button type="button" class="set-del" title="Törlés" (click)="removeDutyRate(i)">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><line x1="4" y1="7" x2="20" y2="7"></line><path d="M9 7 V5 a1 1 0 0 1 1 -1 h4 a1 1 0 0 1 1 1 v2"></path><path d="M6 7 l1 13 a1 1 0 0 0 1 1 h8 a1 1 0 0 0 1 -1 l1 -13"></path></svg>
        </button>
      </div>

      <div class="set-empty" *ngIf="calcLoading">Betöltés…</div>
      <div class="set-empty" *ngIf="!calcLoading && dutyRates.length === 0">Még nincs ország felvéve.</div>

      <button type="button" class="set-add" (click)="addDutyRate()">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><line x1="12" y1="4" x2="12" y2="20"></line><line x1="4" y1="12" x2="20" y2="12"></line></svg>
        Új ország
      </button>
    </div>

  </div>

  <!-- Gyártási paraméterek -->
  <div class="set-card set-prod">
    <div class="set-prod__head">
      <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#21252B" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3"></circle><path d="M12 3 v3 M12 18 v3 M3 12 h3 M18 12 h3 M5.6 5.6 l2.1 2.1 M16.3 16.3 l2.1 2.1 M18.4 5.6 l-2.1 2.1 M7.7 16.3 l-2.1 2.1"></path></svg>
      <h3>Gyártási paraméterek</h3>
    </div>
    <div class="set-prod__row">
      <div class="set-prod__field">
        <span class="set-prod__label">1 perc nyomtatás (gép + áram):</span>
        <input class="set-num-input set-num-input--print" [value]="printPerMin" (change)="onPrintPerMinChange($event)">
        <span class="set-prod__unit">Ft/perc</span>
      </div>
      <div class="set-prod__note">Az anyagárakat az <b>Anyagok</b> oldalon állítod (Ft/kg).</div>
    </div>
  </div>

  <!-- ======================================================================
       Integrációk (Billingo + ShippyPro) — megőrzött funkciók
       ====================================================================== -->
  <div class="set-int-head">
    <h2>Integrációk</h2>
    <div class="set-int-head__sub">Számlázó, címke (ShippyPro, UPS), nyomkövetés (17TRACK) és e-mail küldés kezelése.</div>
  </div>

  <div class="set-error-bar" *ngIf="integrationsLoadFailed">
    <span>Az integrációs beállítások betöltése sikertelen volt.</span>
    <button type="button" class="stk-btn stk-btn--ghost set-retry" (click)="fetchSettings()">Újrapróbálom</button>
  </div>

  <div class="set-int-grid" [class.set-int-grid--loading]="loading">

    <!-- Billingo -->
    <!-- Okos Könyvelőm — az ÚJ számlákat kiállító rendszer (a Billingót váltja) -->
    <section class="set-card set-card--flush">
      <div class="set-card__head">
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#21252B" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="3" width="14" height="18" rx="2"></rect><line x1="9" y1="8" x2="15" y2="8"></line><line x1="9" y1="12" x2="15" y2="12"></line><line x1="9" y1="16" x2="12" y2="16"></line></svg>
        <h3>Okos Könyvelőm</h3>
        <span class="stk-pill" [ngClass]="activeInvoiceProvider === 'okoskonyvelom' ? 'stk-pill--green' : 'stk-pill--yellow'">
          {{ activeInvoiceProvider === 'okoskonyvelom' ? 'Aktív számlázó' : (okosSettings.has_api_key ? 'Beállítva, de nem aktív' : 'API kulcs hiányzik') }}
        </span>
      </div>

      <div class="set-card__body">
        <label class="set-check">
          <input type="checkbox" [(ngModel)]="okosSettings.enabled">
          <span>Az Okos Könyvelőm állítsa ki az új számlákat</span>
        </label>

        <div class="set-field">
          <label class="stk-label">Aktuális API kulcs</label>
          <div class="set-masked">{{ okosSettings.api_key_masked || 'Nincs beállítva' }}</div>
        </div>

        <div class="set-field">
          <label class="stk-label">Új API kulcs megadása</label>
          <input
            class="stk-input"
            type="password"
            [(ngModel)]="okosApiKeyInput"
            autocomplete="off"
            placeholder="Ha üresen hagyod, a jelenlegi marad"
          >
          <div class="set-help">A kulcsot az Okos Könyvelőmben, a Beállítások → API-kulcsok oldalon generálod (olvasás + írás jog).</div>
        </div>

        <label class="set-check">
          <input type="checkbox" [(ngModel)]="clearOkosApiKey" [disabled]="okosApiKeyInput.trim().length > 0">
          <span>Mentéskor törölje a tárolt API kulcsot (és az .env tartalékot használja)</span>
        </label>

        <div class="set-field">
          <label class="stk-label">API cím</label>
          <input class="stk-input" type="text" [(ngModel)]="okosBaseUrlInput" placeholder="https://app.okoskonyvelom.hu">
          <div class="set-help">Üresen hagyva az éles szolgáltatás. Teszthez ide írható a saját példány címe.</div>
        </div>

        <div class="set-field">
          <label class="stk-label">Számlakategória forrásonként</label>
          <div class="set-block-grid">
            <div class="set-block-field">
              <span class="set-sub-label">Etsy</span>
              <select class="stk-input" [(ngModel)]="okosSettings.etsy_category_id">
                <option [ngValue]="null">Nincs besorolás</option>
                <option *ngFor="let category of okosCategoryOptions" [ngValue]="category.id">{{ category.name }}</option>
              </select>
            </div>

            <div class="set-block-field">
              <span class="set-sub-label">Shopify HU (bgfox.hu)</span>
              <select class="stk-input" [(ngModel)]="okosSettings.shopify_hu_category_id">
                <option [ngValue]="null">Nincs besorolás</option>
                <option *ngFor="let category of okosCategoryOptions" [ngValue]="category.id">{{ category.name }}</option>
              </select>
            </div>

            <div class="set-block-field">
              <span class="set-sub-label">Shopify EN (boardgeekfox)</span>
              <select class="stk-input" [(ngModel)]="okosSettings.shopify_en_category_id">
                <option [ngValue]="null">Nincs besorolás</option>
                <option *ngFor="let category of okosCategoryOptions" [ngValue]="category.id">{{ category.name }}</option>
              </select>
            </div>
          </div>
          <div class="set-help" *ngIf="okosCategories.length === 0">
            A kategórialista az API kulcs alapján töltődik be. Ha most üres, előbb ments érvényes kulcsot — a kategóriákat az Okos Könyvelőmben veszed fel.
          </div>
        </div>

        <div class="set-actions">
          <button type="button" class="stk-btn stk-btn--accent" [disabled]="savingOkosKonyvelom" (click)="saveOkosKonyvelomSettings()">
            {{ savingOkosKonyvelom ? 'Mentés…' : 'Okos Könyvelőm mentése' }}
          </button>
        </div>
      </div>
    </section>

    <section class="set-card set-card--flush">
      <div class="set-card__head">
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#21252B" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="3" width="14" height="18" rx="2"></rect><line x1="9" y1="8" x2="15" y2="8"></line><line x1="9" y1="12" x2="15" y2="12"></line><line x1="9" y1="16" x2="12" y2="16"></line></svg>
        <h3>Billingo</h3>
        <span class="stk-pill" [ngClass]="activeInvoiceProvider === 'billingo' ? 'stk-pill--green' : 'stk-pill--yellow'">
          {{ activeInvoiceProvider === 'billingo' ? 'Aktív számlázó' : 'Kikapcsolva (a régi számlák elérhetők)' }}
        </span>
      </div>

      <div class="set-card__body">
        <label class="set-check">
          <input type="checkbox" [(ngModel)]="billingoSettings.enabled">
          <span>A Billingo állítsa ki az új számlákat</span>
        </label>
        <div class="set-help">
          Kikapcsolva sem vész el semmi: a korábban Billingóban kiállított számlák letöltése és
          sztornózása változatlanul működik.
        </div>

        <div class="set-field">
          <label class="stk-label">Aktuális API kulcs</label>
          <div class="set-masked">{{ billingoSettings.api_key_masked || 'Nincs beállítva' }}</div>
        </div>

        <div class="set-field">
          <label class="stk-label">Új API kulcs megadása</label>
          <input
            class="stk-input"
            type="password"
            [(ngModel)]="billingoApiKeyInput"
            autocomplete="off"
            placeholder="Ha üresen hagyod, a jelenlegi marad"
          >
          <div class="set-help">A kulcs az adatbázisban tárolódik, és felülírja az .env értékét.</div>
        </div>

        <label class="set-check">
          <input type="checkbox" [(ngModel)]="clearApiKey" [disabled]="billingoApiKeyInput.trim().length > 0">
          <span>Mentéskor törölje a tárolt API kulcsot (és az .env tartalékot használja)</span>
        </label>

        <div class="set-field">
          <label class="stk-label">Dokumentum létrehozási mód</label>
          <div class="set-opts">
            <label class="set-opt" [class.set-opt--on]="billingoSettings.document_insert_type === 'invoice'">
              <input type="radio" name="billingoDocumentType" value="invoice" [(ngModel)]="billingoSettings.document_insert_type">
              <strong>Azonnali számla</strong>
              <span>A rendszer rögtön számla dokumentumot hoz létre.</span>
            </label>
            <label class="set-opt" [class.set-opt--on]="billingoSettings.document_insert_type === 'draft'">
              <input type="radio" name="billingoDocumentType" value="draft" [(ngModel)]="billingoSettings.document_insert_type">
              <strong>Piszkozat (draft)</strong>
              <span>Piszkozat készül Billingóban, teszteléshez.</span>
            </label>
          </div>
        </div>

        <div class="set-field">
          <label class="stk-label">Billingo számlatömb</label>
          <div class="set-block-grid">
            <div class="set-block-field">
              <span class="set-sub-label">Etsy</span>
              <select class="stk-input" [(ngModel)]="billingoSettings.etsy_invoice_block_id">
                <option [ngValue]="null">Automatikus / alapértelmezett</option>
                <option *ngFor="let block of billingoBlockOptions" [ngValue]="block.id">
                  {{ formatBillingoBlockLabel(block) }}
                </option>
              </select>
            </div>

            <div class="set-block-field">
              <span class="set-sub-label">Shopify HU (bgfox.hu)</span>
              <select class="stk-input" [(ngModel)]="billingoSettings.shopify_hu_invoice_block_id">
                <option [ngValue]="null">Automatikus / alapértelmezett</option>
                <option *ngFor="let block of billingoBlockOptions" [ngValue]="block.id">
                  {{ formatBillingoBlockLabel(block) }}
                </option>
              </select>
            </div>

            <div class="set-block-field">
              <span class="set-sub-label">Shopify EN (boardgeekfox)</span>
              <select class="stk-input" [(ngModel)]="billingoSettings.shopify_en_invoice_block_id">
                <option [ngValue]="null">Automatikus / alapértelmezett</option>
                <option *ngFor="let block of billingoBlockOptions" [ngValue]="block.id">
                  {{ formatBillingoBlockLabel(block) }}
                </option>
              </select>
            </div>
          </div>
          <div class="set-help" *ngIf="billingoBlocks.length === 0">
            A számlatömb lista a Billingo API kulcs alapján töltődik be. Ha most üres, előbb ments érvényes Billingo kulcsot.
          </div>
        </div>

        <div class="set-actions">
          <button type="button" class="stk-btn stk-btn--accent" [disabled]="savingBillingo" (click)="saveBillingoSettings()">
            {{ savingBillingo ? 'Mentés…' : 'Billingo mentése' }}
          </button>
        </div>
      </div>
    </section>

    <!-- ShippyPro -->
    <section class="set-card set-card--flush">
      <div class="set-card__head">
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#21252B" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="7" width="12" height="9" rx="1.5"></rect><path d="M14 10 h4 l3 3 v3 h-7"></path><circle cx="7" cy="18.5" r="1.7"></circle><circle cx="17" cy="18.5" r="1.7"></circle></svg>
        <h3>ShippyPro</h3>
        <span class="stk-pill" [ngClass]="(shippyProSettings.has_api_key && !!shippyProSettings.api_orders_id) ? 'stk-pill--green' : 'stk-pill--yellow'">
          {{ shippyProSettings.has_api_key && !!shippyProSettings.api_orders_id ? 'Készen áll' : 'Hiányos beállítás' }}
        </span>
      </div>

      <div class="set-card__body">
        <div class="set-field">
          <label class="stk-label">Aktuális API kulcs</label>
          <div class="set-masked">{{ shippyProSettings.api_key_masked || 'Nincs beállítva' }}</div>
        </div>

        <div class="set-field">
          <label class="stk-label">Új API kulcs megadása</label>
          <input
            class="stk-input"
            type="password"
            [(ngModel)]="shippyProApiKeyInput"
            autocomplete="off"
            placeholder="Ha üresen hagyod, a jelenlegi marad"
          >
        </div>

        <label class="set-check">
          <input type="checkbox" [(ngModel)]="clearShippyProApiKey" [disabled]="shippyProApiKeyInput.trim().length > 0">
          <span>Mentéskor törölje a tárolt API kulcsot (és az .env tartalékot használja)</span>
        </label>

        <div class="set-field">
          <label class="stk-label">API Orders Folder ID (SHIPPYPRO_API_ORDERS_ID)</label>
          <input
            class="stk-input"
            type="number"
            min="1"
            step="1"
            [(ngModel)]="shippyProApiOrdersIdInput"
            placeholder="Pl.: 12345"
          >
          <div class="set-help">Ez kötelező a PutOrder/Ship hívásokhoz. Az adatbázis-érték elsőbbséget élvez az .env felett.</div>
        </div>

        <label class="set-check">
          <input type="checkbox" [(ngModel)]="clearShippyProApiOrdersId" [disabled]="hasShippyProApiOrdersIdInput()">
          <span>Mentéskor törölje a tárolt API Orders ID-t (és az .env tartalékot használja)</span>
        </label>

        <div class="set-actions">
          <button type="button" class="stk-btn stk-btn--accent" [disabled]="savingShippyPro" (click)="saveShippyProSettings()">
            {{ savingShippyPro ? 'Mentés…' : 'ShippyPro mentése' }}
          </button>
        </div>
      </div>
    </section>

    <!-- E-mail (SMTP) — a Support határidő-értesítői ezen mennek ki -->
    <section class="set-card set-card--flush">
      <div class="set-card__head">
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#21252B" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="14" rx="2"></rect><polyline points="3,7 12,13 21,7"></polyline></svg>
        <h3>E-mail küldés</h3>
        <span class="stk-pill" [ngClass]="mailSettings.configured ? 'stk-pill--green' : 'stk-pill--yellow'">
          {{ mailSettings.configured ? 'Beállítva' : 'Nincs beállítva' }}
        </span>
      </div>

      <div class="set-card__body">
        <div class="set-help">A Support emlékeztetők és taskok határidője előtt 1 órával ezen keresztül megy az e-mail a felelősöknek. Bármilyen SMTP jó: a céges levelezés, Gmail alkalmazásjelszóval, vagy egy küldő szolgáltatás.</div>

        <div class="set-field">
          <label class="stk-label">SMTP szerver</label>
          <input class="stk-input" type="text" [(ngModel)]="mailForm.host" placeholder="pl. smtp.gmail.com" autocomplete="off">
        </div>
        <div class="set-field">
          <label class="stk-label">Port</label>
          <input class="stk-input" type="number" min="1" [(ngModel)]="mailForm.port" placeholder="587 (STARTTLS) vagy 465 (SSL)">
        </div>
        <label class="set-check">
          <input type="checkbox" [(ngModel)]="mailForm.secure">
          <span>SSL/TLS kapcsolat (465-ös porthoz)</span>
        </label>
        <div class="set-field">
          <label class="stk-label">Felhasználónév</label>
          <input class="stk-input" type="text" [(ngModel)]="mailForm.username" placeholder="pl. ertesito@bgfox.hu" autocomplete="off">
        </div>
        <div class="set-field">
          <label class="stk-label">Jelszó</label>
          <input class="stk-input" type="password" [(ngModel)]="mailForm.password" autocomplete="new-password"
                 [placeholder]="mailSettings.has_password ? 'Be van állítva — ha üresen hagyod, a jelenlegi marad' : 'SMTP jelszó vagy alkalmazásjelszó'">
        </div>
        <label class="set-check">
          <input type="checkbox" [(ngModel)]="clearMailPassword" [disabled]="mailForm.password.length > 0">
          <span>Mentéskor törölje a tárolt jelszót</span>
        </label>
        <div class="set-field">
          <label class="stk-label">Feladó e-mail</label>
          <input class="stk-input" type="email" [(ngModel)]="mailForm.from_email" placeholder="pl. ertesito@bgfox.hu" autocomplete="off">
        </div>
        <div class="set-field">
          <label class="stk-label">Feladó neve</label>
          <input class="stk-input" type="text" [(ngModel)]="mailForm.from_name" placeholder="BGFox ERP" autocomplete="off">
        </div>

        <div class="set-actions">
          <button type="button" class="stk-btn stk-btn--accent" [disabled]="savingMail" (click)="saveMailSettings()">
            {{ savingMail ? 'Mentés…' : 'E-mail mentése' }}
          </button>
        </div>

        <div class="set-field" *ngIf="mailSettings.configured">
          <label class="stk-label">Próbalevél</label>
          <input class="stk-input" type="email" [(ngModel)]="mailTestTo" placeholder="címzett e-mail" autocomplete="off">
          <div class="set-help">Mentés után küldj egy próbalevelet, hogy lásd, tényleg működik.</div>
        </div>
        <div class="set-actions" *ngIf="mailSettings.configured">
          <button type="button" class="stk-btn stk-btn--ghost" [disabled]="sendingMailTest" (click)="sendMailTest()">
            {{ sendingMailTest ? 'Küldés…' : 'Próbalevél küldése' }}
          </button>
        </div>
      </div>
    </section>

    <!-- Foxi — az ERP MI-munkatársa (Claude) -->
    <section class="set-card set-card--flush">
      <div class="set-card__head">
        <img src="assets/foxi.png" alt="" width="20" height="20" style="border-radius:50%">
        <h3>Foxi (MI-munkatárs)</h3>
        <span class="stk-pill" [ngClass]="foxiSettings.has_api_key && foxiSettings.enabled ? 'stk-pill--green' : 'stk-pill--yellow'">
          {{ !foxiSettings.has_api_key ? 'API kulcs hiányzik' : (foxiSettings.enabled ? 'Bekapcsolva' : 'Kikapcsolva') }}
        </span>
      </div>

      <div class="set-card__body">
        <div class="set-help">Foxi a csapatchatben válaszol (privátban vagy „&#64;Foxi"-val a Fő chatben), belelát az ERP adataiba, és időzített feladatokat is végez. Az „agya" az Anthropic Claude; a használat díját az Anthropic számolja fel.</div>

        <div class="set-field">
          <label class="stk-label">Aktuális API kulcs</label>
          <div class="set-masked">{{ foxiSettings.api_key_masked || 'Nincs beállítva' }}</div>
        </div>

        <div class="set-field">
          <label class="stk-label">Új API kulcs megadása</label>
          <input class="stk-input" type="password" [(ngModel)]="foxiApiKeyInput" autocomplete="off" placeholder="sk-ant-… (ha üresen hagyod, a jelenlegi marad)">
          <div class="set-help">console.anthropic.com → bejelentkezés → Billing: egyenleg feltöltése → API Keys → Create Key. A kulcsot csak egyszer mutatja, rögtön másold ide.</div>
        </div>

        <label class="set-check">
          <input type="checkbox" [(ngModel)]="clearFoxiApiKey" [disabled]="foxiApiKeyInput.trim().length > 0">
          <span>Mentéskor törölje a tárolt API kulcsot</span>
        </label>

        <div class="set-field">
          <label class="stk-label">Modell</label>
          <select class="stk-input" [(ngModel)]="foxiModelInput">
            <option *ngFor="let m of foxiSettings.models" [value]="m">{{ foxiModelLabel(m) }}</option>
          </select>
        </div>

        <div class="set-field">
          <label class="stk-label">Napi költségkeret (USD)</label>
          <input class="stk-input" type="number" min="0" step="0.5" [(ngModel)]="foxiBudgetInput">
          <div class="set-help">Ha a napi becsült költés eléri, Foxi aznapra szünetel. 0 = nincs keret. Ma eddig: {{ foxiSettings.today_cost_usd | number:'1.2-2' }} USD · ebben a hónapban: {{ foxiSettings.month_cost_usd | number:'1.2-2' }} USD</div>
        </div>

        <label class="set-check">
          <input type="checkbox" [(ngModel)]="foxiEnabledInput">
          <span>Foxi bekapcsolva (válaszol a chatben, futnak az időzített feladatai)</span>
        </label>

        <div class="set-actions">
          <button type="button" class="stk-btn stk-btn--accent" [disabled]="savingFoxi" (click)="saveFoxiSettings()">
            {{ savingFoxi ? 'Mentés…' : 'Foxi mentése' }}
          </button>
        </div>
      </div>
    </section>

    <!-- Jump & Hide webshop (Medusa) — a webshop rendelései 5 percenként bejönnek az ERP-be -->
    <section class="set-card set-card--flush">
      <div class="set-card__head">
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#21252B" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9 L4.5 4 H19.5 L21 9"></path><path d="M3 9 h18 v2 a3 3 0 0 1 -6 0 a3 3 0 0 1 -6 0 a3 3 0 0 1 -6 0 Z"></path><path d="M5 13 V20 H19 V13"></path></svg>
        <h3>Jump &amp; Hide webshop</h3>
        <span class="stk-pill" [ngClass]="medusaSettings.enabled ? 'stk-pill--green' : 'stk-pill--yellow'">
          {{ medusaSettings.enabled ? 'Rendelésszinkron bekapcsolva' : 'Kikapcsolva' }}
        </span>
      </div>

      <div class="set-card__body">
        <div class="set-help">A jumpandhide.com rendelései 5 percenként bejönnek a „Jump &amp; Hide webshop” shop alá, cikkszám szerint készletet foglalnak. Az utolsó 14 nap rendeléseit nézi.</div>

        <div class="set-field">
          <label class="stk-label">Webshop backend címe</label>
          <input class="stk-input" type="text" [(ngModel)]="medusaBaseUrlInput" autocomplete="off" placeholder="https://jumpandhide.com">
        </div>

        <div class="set-field">
          <label class="stk-label">Aktuális API kulcs</label>
          <div class="set-masked">{{ medusaSettings.api_key_masked || 'Nincs beállítva' }}</div>
        </div>

        <div class="set-field">
          <label class="stk-label">Új API kulcs megadása</label>
          <input class="stk-input" type="password" [(ngModel)]="medusaApiKeyInput" autocomplete="off" placeholder="sk_… (ha üresen hagyod, a jelenlegi marad)">
          <div class="set-help">A webshop adminjában: Beállítások → Secret API Keys → új kulcs (pl. „ERP”).</div>
        </div>

        <label class="set-check">
          <input type="checkbox" [(ngModel)]="medusaEnabledInput">
          <span>Rendelésszinkron bekapcsolva</span>
        </label>

        <div class="set-field" *ngIf="medusaSettings.last_sync_result">
          <label class="stk-label">Utolsó szinkron</label>
          <div class="set-masked">{{ medusaSettings.last_sync_at | date:'yyyy.MM.dd. HH:mm' }} — {{ medusaSettings.last_sync_result }}</div>
        </div>

        <div class="set-actions">
          <button type="button" class="stk-btn" [disabled]="syncingMedusa || !medusaSettings.has_api_key" (click)="syncMedusaNow()">
            {{ syncingMedusa ? 'Szinkron…' : 'Szinkron most' }}
          </button>
          <button type="button" class="stk-btn stk-btn--accent" [disabled]="savingMedusa" (click)="saveMedusaSettings()">
            {{ savingMedusa ? 'Mentés…' : 'Webshop mentése' }}
          </button>
        </div>
      </div>
    </section>

    <!-- UPS — közvetlen címkézés (developer.ups.com), a Spring GDS mellett választható -->
    <section class="set-card set-card--flush">
      <div class="set-card__head">
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#21252B" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7.5 L12 3 L21 7.5 V16.5 L12 21 L3 16.5 Z"></path><polyline points="3,7.5 12,12 21,7.5"></polyline><line x1="12" y1="12" x2="12" y2="21"></line></svg>
        <h3>UPS</h3>
        <span class="stk-pill" [ngClass]="upsSettings?.configured ? 'stk-pill--green' : 'stk-pill--yellow'">
          {{ upsSettings?.configured ? (upsSettings?.environment === 'test' ? 'Teszt környezet' : 'Bekapcsolva') : 'Kulcs hiányzik' }}
        </span>
      </div>

      <div class="set-card__body">
        <div class="set-help">Közvetlen UPS címke a saját szerződéses árakon: árlekérés, szolgáltatás-választás, vámáru-számla HS kóddal. A kulcsok a developer.ups.com „Apps" menüjében (API-k: Authorization, Rating, Shipping).</div>

        <div class="set-ups-grid">
          <div class="set-field">
            <label class="stk-label">Client ID {{ upsSettings?.client_id_masked ? '(' + upsSettings?.client_id_masked + ')' : '' }}</label>
            <input class="stk-input" type="password" [(ngModel)]="upsClientIdInput" autocomplete="off" placeholder="Ha üresen hagyod, a jelenlegi marad">
          </div>
          <div class="set-field">
            <label class="stk-label">Client Secret {{ upsSettings?.has_client_secret ? '(beállítva)' : '' }}</label>
            <input class="stk-input" type="password" [(ngModel)]="upsClientSecretInput" autocomplete="off" placeholder="Ha üresen hagyod, a jelenlegi marad">
          </div>
          <div class="set-field">
            <label class="stk-label">UPS fiókszám (Shipper Number)</label>
            <input class="stk-input" [(ngModel)]="upsAccountInput" maxlength="10" placeholder="pl. A1B2C3">
          </div>
          <div class="set-field">
            <label class="stk-label">Környezet</label>
            <select class="stk-input" [(ngModel)]="upsEnvironmentInput">
              <option value="production">Éles (onlinetools.ups.com)</option>
              <option value="test">Teszt (wwwcie.ups.com)</option>
            </select>
          </div>
        </div>

        <div class="stk-label set-ups-sub">Feladó</div>
        <div class="set-ups-grid">
          <div class="set-field"><label class="stk-label">Cégnév</label><input class="stk-input" [(ngModel)]="upsConfig.shipper_name"></div>
          <div class="set-field"><label class="stk-label">Kapcsolattartó</label><input class="stk-input" [(ngModel)]="upsConfig.shipper_attention"></div>
          <div class="set-field"><label class="stk-label">Utca, házszám</label><input class="stk-input" [(ngModel)]="upsConfig.shipper_street1"></div>
          <div class="set-field"><label class="stk-label">Cím 2. sor</label><input class="stk-input" [(ngModel)]="upsConfig.shipper_street2"></div>
          <div class="set-field"><label class="stk-label">Irányítószám</label><input class="stk-input" [(ngModel)]="upsConfig.shipper_zip"></div>
          <div class="set-field"><label class="stk-label">Város</label><input class="stk-input" [(ngModel)]="upsConfig.shipper_city"></div>
          <div class="set-field"><label class="stk-label">Ország (ISO)</label><input class="stk-input" maxlength="2" [(ngModel)]="upsConfig.shipper_country"></div>
          <div class="set-field"><label class="stk-label">Telefon</label><input class="stk-input" [(ngModel)]="upsConfig.shipper_phone"></div>
          <div class="set-field"><label class="stk-label">E-mail</label><input class="stk-input" [(ngModel)]="upsConfig.shipper_email"></div>
          <div class="set-field"><label class="stk-label">Adószám / EORI</label><input class="stk-input" [(ngModel)]="upsConfig.shipper_tax_id" placeholder="HU12345678"></div>
        </div>

        <div class="stk-label set-ups-sub">Alapértékek</div>
        <div class="set-ups-grid">
          <div class="set-field">
            <label class="stk-label">Szolgáltatás</label>
            <select class="stk-input" [(ngModel)]="upsConfig.default_service_code">
              <option *ngFor="let s of upsServiceOptions" [value]="s.code">{{ s.name }}</option>
            </select>
          </div>
          <div class="set-field">
            <label class="stk-label">Vámot fizeti</label>
            <select class="stk-input" [(ngModel)]="upsConfig.default_duty_payer">
              <option value="receiver">Címzett (DAP)</option>
              <option value="shipper">Feladó (DDP)</option>
            </select>
          </div>
          <div class="set-field"><label class="stk-label">Alap HS kód</label><input class="stk-input" [(ngModel)]="upsConfig.default_hs_code" placeholder="9503000090"></div>
          <div class="set-field"><label class="stk-label">Származási ország</label><input class="stk-input" maxlength="2" [(ngModel)]="upsConfig.default_origin_country" placeholder="HU"></div>
          <div class="set-field"><label class="stk-label">Csomag (H×Sz×M cm)</label>
            <div class="set-ups-dims">
              <input class="stk-input" type="number" min="1" [(ngModel)]="upsConfig.default_length_cm">
              <input class="stk-input" type="number" min="1" [(ngModel)]="upsConfig.default_width_cm">
              <input class="stk-input" type="number" min="1" [(ngModel)]="upsConfig.default_height_cm">
            </div>
          </div>
          <div class="set-field"><label class="stk-label">Alap súly (kg)</label><input class="stk-input" type="number" step="0.01" min="0.1" [(ngModel)]="upsConfig.default_weight_kg"></div>
          <div class="set-field">
            <label class="stk-label">Címke formátum</label>
            <select class="stk-input" [(ngModel)]="upsConfig.label_format">
              <option value="ZPL">4×6 hőpapír (ZPL → PDF)</option>
              <option value="GIF">Kép (GIF → PDF)</option>
            </select>
          </div>
        </div>
        <div class="set-help">A termékek HS kódját és angol vámleírását a komponens szerkesztőjében (Szállítás / vám) vagy a címke-dialógusban lehet megadni; ahol nincs, az alap HS kód megy.</div>

        <div class="set-actions">
          <button type="button" class="stk-btn stk-btn--ghost" [disabled]="testingUps || !upsSettings?.configured" (click)="testUpsConnection()">
            {{ testingUps ? 'Próba…' : 'Kapcsolat próba' }}
          </button>
          <button type="button" class="stk-btn stk-btn--accent" [disabled]="savingUps" (click)="saveUpsSettings()">
            {{ savingUps ? 'Mentés…' : 'UPS mentése' }}
          </button>
        </div>
      </div>
    </section>

    <!-- 17TRACK — nyomkövetés, elsődleges forrás (használat szerint fizetős) -->
    <section class="set-card set-card--flush">
      <div class="set-card__head">
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#21252B" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="10.5" r="2.4"></circle><path d="M12 21 C8 16.5 6 13.5 6 10.5 a6 6 0 0 1 12 0 C18 13.5 16 16.5 12 21 Z"></path></svg>
        <h3>17TRACK</h3>
        <span class="stk-pill" [ngClass]="seventeenSettings.has_api_key ? 'stk-pill--green' : 'stk-pill--yellow'">
          {{ seventeenSettings.has_api_key ? 'Nyomkövetés bekapcsolva' : 'API kulcs hiányzik' }}
        </span>
      </div>

      <div class="set-card__body">
        <div class="set-help">A csomagok nyomkövetése innen jön, futártól függetlenül. Egy csomag egyszer fogyaszt kvótát (regisztráció), a frissítés és a webhook nem.</div>

        <div class="set-field">
          <label class="stk-label">Aktuális API kulcs</label>
          <div class="set-masked">{{ seventeenSettings.api_key_masked || 'Nincs beállítva' }}</div>
        </div>

        <div class="set-field">
          <label class="stk-label">Új API kulcs megadása</label>
          <input
            class="stk-input"
            type="password"
            [(ngModel)]="seventeenApiKeyInput"
            autocomplete="off"
            placeholder="Ha üresen hagyod, a jelenlegi marad"
          >
          <div class="set-help">A 17TRACK API adminban: Settings → Security → Access Key. Webhook cím ugyanott: <code>https://erp.bgfox.hu/api/tracking/webhooks/17track</code></div>
        </div>

        <label class="set-check">
          <input type="checkbox" [(ngModel)]="clearSeventeenApiKey" [disabled]="seventeenApiKeyInput.trim().length > 0">
          <span>Mentéskor törölje a tárolt API kulcsot (és az .env tartalékot használja)</span>
        </label>

        <div class="set-field" *ngIf="seventeenSettings.has_api_key">
          <label class="stk-label">Kvóta</label>
          <div class="set-masked" *ngIf="seventeenQuotaLoading">Lekérdezés…</div>
          <div class="set-masked" *ngIf="!seventeenQuotaLoading && seventeenQuota.error">{{ seventeenQuota.error }}</div>
          <div class="set-masked" *ngIf="!seventeenQuotaLoading && !seventeenQuota.error">{{ seventeenQuotaLabel || 'nincs adat' }}</div>
        </div>

        <div class="set-actions">
          <button type="button" class="stk-btn stk-btn--accent" [disabled]="savingSeventeen" (click)="saveSeventeenSettings()">
            {{ savingSeventeen ? 'Mentés…' : '17TRACK mentése' }}
          </button>
        </div>
      </div>
    </section>


  </div>
</div>
